import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './FakeVideoPlayer.scss';

const FakeVideoPlayer = props => {
  const { handleClick, children } = props;

  return (
    <div className={'fake-video-player'}>
      {children}
      <div className={'fake-video-player__container'}>
        <button
          onClick={handleClick}
          ariaLabel={'Play button'}
        >
          <span className={'fake-video-player__play-icon'} />
        </button>
      </div>
    </div>
  );
};

FakeVideoPlayer.propTypes = {
  handleClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default memo(FakeVideoPlayer);
